<template>
  <v-footer color="grey-darken-4">
    <v-container>
      <v-row>
        <v-col class="d-none d-lg-flex" cols="3"></v-col>
        <v-col cols="12" sm="6" md="6" lg="3" xl="3">
          <h3>
            <span class="text-orange-darken-4">{{
              $t("footer.contact_undergraduate")
            }}</span>
          </h3>
          <v-divider></v-divider>
          <v-icon>mdi-phone</v-icon> : 0 2329 8201 {{ $t("footer.ext") }} 401 -
          404, 502<br />
          <v-icon>mdi-phone</v-icon> : 0 2329 8202 {{ $t("footer.ext") }} 401 -
          404, 502<br />
          <v-icon>mdi-phone</v-icon> : 0 2329 8203 {{ $t("footer.ext") }} 401 -
          404, 502<br />
          <v-icon>mdi-phone</v-icon> : 0 2329 8205 {{ $t("footer.ext") }} 401 -
          404, 502<br />
          <v-icon>mdi-phone</v-icon> : 0 2329 8163 {{ $t("footer.ext") }} 401 -
          404, 502<br />
          <v-icon>mdi-at</v-icon> : admission-reg@kmitl.ac.th<br />
          <v-icon>mdi-facebook</v-icon> :
          <a
            href="https://www.facebook.com/Admission.KMITL"
            target="blank"
            style="text-decoration: none; color: white"
            >admission.kmitl</a
          >
        </v-col>
        <v-col cols="12" sm="6" md="6" lg="3" xl="3">
          <h3>
            <span class="text-orange-darken-4">{{
              $t("footer.contact_graduate")
            }}</span>
          </h3>
          <v-divider></v-divider>
          <v-icon>mdi-phone</v-icon> : 0 2329 8201 {{ $t("footer.ext") }} 101 - 102, 502 - 503<br />
          <v-icon>mdi-phone</v-icon> : 0 2329 8202 {{ $t("footer.ext") }} 101 - 102, 502 - 503<br />
          <v-icon>mdi-phone</v-icon> : 0 2329 8203 {{ $t("footer.ext") }} 101 - 102, 502 - 503<br />
          <v-icon>mdi-phone</v-icon> : 0 2329 8205 {{ $t("footer.ext") }} 101 - 102, 502 - 503<br />
          <v-icon>mdi-phone</v-icon> : 0 2329 8163 {{ $t("footer.ext") }} 101 - 102, 502 - 503<br />
          <v-icon>mdi-at</v-icon> : grad-reg@kmitl.ac.th<br />
          <v-icon>mdi-facebook</v-icon> :
          <a
            href="https://www.facebook.com/reg.kmitl"
            target="blank"
            style="text-decoration: none; color: white"
            >reg.kmitl</a
          >
        </v-col>
        <v-col cols="12" sm="12" md="12" lg="3" xl="3">
          <h3>
            <span class="text-orange-darken-4"
              >{{ $t("footer.registrar") }}
            </span>
          </h3>
          <v-divider></v-divider>
          {{ $t("app_bar.university_name") }}<br />
          {{ $t("footer.address1") }}<br />
          {{ $t("footer.address2") }}<br />
          {{ $t("footer.address3") }}
        </v-col>
      </v-row>

      <v-row>
        <v-col class="d-none d-lg-flex" cols="3"></v-col>
        <v-col cols="12" sm="12" md="12" lg="9" xl="9">
          <h3>
            <span class="text-orange-darken-4"
              >King Mongkut's Institute of Technology Ladkrabang</span
            >
            2024-{{ new Date().getFullYear() }} All Rights Reserved.
          </h3>
        </v-col>
      </v-row>
    </v-container>
  </v-footer>
</template>

<style lang="scss" scoped>
footer {
  flex: none;
}
</style>
